import TeacherLeaveEdit from "@/controllers/teacher_leave/leave-edit.js";
import CONFIG from "@/assets/js/config.custom.js";
import axios from "axios";

export default {
  extends: TeacherLeaveEdit,
  methods: {
    getDetail() {
      axios.get(`${this.leaveApiBase}/detail/${this.$route.params.id}`)
        .then(res => {
          this.leaveData = res.data;

          // Non-HR roles cannot edit approved leave
          if (!this.isHrOperator && this.leaveData.status == CONFIG.SHIFT_LEAVE_STATUS.APPROVE) {
            this.$notification.error("Approved leave records cannot be edited.", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({ name: 'teacherLeaveList' });
            return;
          }

          if (!this.leaveData.employee_id && this.leaveData.employee_record_id) {
            this.leaveData.employee_id = this.leaveData.employee_record_id;
          }
          if (this.leaveData.employee_id) this.getLeaveLists();
          if (res.data.leave_images) {
            this.existingImages = res.data.leave_images;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
            return;
          }
          if (error.response && error.response.status == 403) {
            this.$notification.error(
              error.response.data?.message || "You are not allowed to edit this leave record.",
              {
                timer: 3,
                position: "bottomCenter"
              }
            );
            this.$router.push({ name: 'teacherLeaveList' });
          }
          this.isLoading = false;
          console.log("Leave Detail API Error", error);
        })
    },
  }
};
